import http from '@/utils/request'
import {ref, reactive, watch} from 'vue'
import {getValue} from '@/utils/props-formatter'
import {listToTree} from '@/utils/objects'

const createParams = (api, params, variable) => {
    const p = {url: api.url, method: api.method || 'GET', params: api.params, data: api.data}
    const margParam = () => {
        const ps = {}
        Object.assign(ps, p.params || {}, p.data || {}, params || {}, variable || {})
        return ps
    }
    if (p.method && p.method.toUpperCase() != 'GET') {
        p.data = Array.isArray(api.data) ? api.data : margParam()
    } else {
        p.params = margParam()
    }
    // console.log(p)
    return p
}

function debounce(fn, time = 10) {
    let timer = null
    return function (...args) {
        if (timer) clearTimeout(timer)
        timer = setTimeout(() => {
            fn.apply(null, args)
        }, time)
    }
}

export default {

    create: (api, p, vars) => {
        const params = reactive(p || {})
        const variable = reactive(vars || {})
        // const loading = ref(false)
        const result = ref()
        const error = ref()
        // console.log(api)
        const getList = () => {
            return result.value?.data || result.value || []//列表数据
        }
        const getTree = () => {
            return api.tree ? listToTree(getList(), (i) => getValue(i, api.tree.id, 0), (i) => getValue(i, api.tree.pid, 0)) : []
        }

        const data = reactive({
            loading: false,
            variable,
            params,
            api,
            list: [],
            tree: [],
            total: 0,
            status: undefined,
            result: undefined,
            data: undefined
        })
        // console.log(api)
        const resultData = () => Object.assign(data, {
            data: api.dataAdapter ? api.dataAdapter(result.value) : (result.value?.data || result.value),//请求数据
            loading: false,//请求状态
            run,//手动执行请求
            result: result.value,//请求结果
            error: error.value,
            total: api.totalAdapter ? api.totalAdapter(result.value) : (result.value?.count || 0),//列表夯数
            tree: getTree(),
            list: getList(),
            status: result.value?.code,//请求结果
            api: api,
            params: params,
            variable: variable
        })
        const execute = (params) => {
			data.loading = true
            result.value = undefined
            error.value = undefined
            return http.request(params).then(r => {
                // console.log(r, params, variable)
                // loading.value = false
                result.value = r?.data
                return Promise.resolve(r)
            }).catch(e => {
                console.error('请求错误', params, api, e)
                // loading.value = false
                error.value = e
                result.value = undefined
                return Promise.reject(e)
            }).finally(resultData)
        }
        const debounceExecute = debounce(execute)
        // console.log(debounceExecute)
        watch(variable, () => {
            debounceExecute(createParams(api, params, variable))
        }, {immediate: api.immediate})
        //手动请求
        const run = (p = {}) => {
            return execute(createParams(api, Object.assign(params, p || {}), variable))
        }
        data.run = run
        return data
    }
}
